<template>
  <div
    :class="{ 'switch-field': true, 'form-group': true, 'mr-1': true, inline }"
  >
    <span v-if="!inline">
      <label :for="id" class="switch-label form-label">{{ label }}</label>
    </span>
    <span>
      <label class="switch">
        <input type="checkbox" v-model="checked" />
        <span class="slider round"></span>
      </label>
    </span>
    <span v-if="inline">
      <label :for="id" class="switch-label form-label">{{ label }}</label>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    checked: {
      get: function() {
        return this.modelValue;
      },
      set: function(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.switch-field {
  margin-top: 0.25rem;

  &.inline {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    & .switch-label {
      margin-left: 3px;
    }
  }
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: $primary;
}

input:focus + .slider {
  box-shadow: 0 0 1px $primary;
}

input:checked + .slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
